import React from "react";
import "./corporate.css";

const MDMessage = () => {
  return (
    <section className="md-page">

        <div className="team-banner">
            <img src="/corporate/MDmessage.png" alt="" />
        </div>


      <h1 className="md-title">MD Message</h1>

      <p className="md-quote">
        <strong>“We believe in continuous strive aligning with our social
        responsibilities with a goal remain to ahead of our competitors.”</strong>
      </p>

      <div className="md-content">
       
        <div className="md-image">
          <img src="/images/MD.jpeg"  alt="Managing Director"
          />
        </div>

    
        <div className="md-text">
          <p>
            We pride ourselves on being more than just an EPC contractor — we are your trusted partner in delivering complex infrastructure and industrial projects that shape tomorrow’s world. Since our inception, we have built our reputation on a foundation of technical excellence, uncompromising quality, and a steadfast commitment to safety and sustainability.
          </p>

          <p>
           In an industry that constantly evolves with technological advancements and global demands, we remain agile and forward-thinking. Our multidisciplinary teams work seamlessly across engineering, procurement, and construction functions to ensure each project is executed with precision, efficiency, and integrity.
          </p>

          <p>
          Every project we undertake is driven by a clear vision to deliver value to our clients, empower communities, and contribute meaningfully to economic growth. We are committed to fostering innovation, nurturing talent, and building long-term partnerships that go beyond project completion.
          </p>

          <p>
           I look to the future with a great deal of optimism, expecting conditions for increasing our competitiveness and growth will continue to in the coming year. Your Company is well positioned to lead growth in the coming years.
          </p>
          <p>
            At Swastika, we believe that sustained economic growth cannot be achieved without social progress and an organization must maintain highest standards of corporate behaviour towards its investors, stakeholders, employees and societies in which it operates.
          </p>
          <p>
            At the end, I am thankful to you all for your dynamic effort and consistent support to our organization and your belief in us and wish for your continuous cooperation in our future journey.
          </p>
          <p className="md-sign">
            <strong>Mr. Vinay Gupta <br />
            Managing Director </strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default MDMessage;




